// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/retrieve_project_credits.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/retrieve_project_credits.proto.
 */
export const file_vision_billing_v1_retrieve_project_credits: GenFile = /*@__PURE__*/
  fileDesc("CjB2aXNpb24vYmlsbGluZy92MS9yZXRyaWV2ZV9wcm9qZWN0X2NyZWRpdHMucHJvdG8SGHByb3Rvcy52aXNpb24uYmlsbGluZy52MSKNAQodUmV0cmlldmVQcm9qZWN0Q3JlZGl0c1JlcXVlc3QSTgoGcGFyYW1zGAEgASgLMj4ucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLlJldHJpZXZlUHJvamVjdENyZWRpdHNSZXF1ZXN0LlBhcmFtcxocCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCSKVAQoeUmV0cmlldmVQcm9qZWN0Q3JlZGl0c1Jlc3BvbnNlEk8KBnJlc3VsdBgBIAEoCzI/LnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5SZXRyaWV2ZVByb2plY3RDcmVkaXRzUmVzcG9uc2UuUmVzdWx0GiIKBlJlc3VsdBIYChBjcmVkaXRzX3JlZnVuZGVkGAEgASgDYgZwcm90bzM");

/**
 * @generated from message protos.vision.billing.v1.RetrieveProjectCreditsRequest
 */
export type RetrieveProjectCreditsRequest = Message<"protos.vision.billing.v1.RetrieveProjectCreditsRequest"> & {
  /**
   * @generated from field: protos.vision.billing.v1.RetrieveProjectCreditsRequest.Params params = 1;
   */
  params?: RetrieveProjectCreditsRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.RetrieveProjectCreditsRequest.
 * Use `create(RetrieveProjectCreditsRequestSchema)` to create a new message.
 */
export const RetrieveProjectCreditsRequestSchema: GenMessage<RetrieveProjectCreditsRequest> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_retrieve_project_credits, 0);

/**
 * @generated from message protos.vision.billing.v1.RetrieveProjectCreditsRequest.Params
 */
export type RetrieveProjectCreditsRequest_Params = Message<"protos.vision.billing.v1.RetrieveProjectCreditsRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message protos.vision.billing.v1.RetrieveProjectCreditsRequest.Params.
 * Use `create(RetrieveProjectCreditsRequest_ParamsSchema)` to create a new message.
 */
export const RetrieveProjectCreditsRequest_ParamsSchema: GenMessage<RetrieveProjectCreditsRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_retrieve_project_credits, 0, 0);

/**
 * @generated from message protos.vision.billing.v1.RetrieveProjectCreditsResponse
 */
export type RetrieveProjectCreditsResponse = Message<"protos.vision.billing.v1.RetrieveProjectCreditsResponse"> & {
  /**
   * @generated from field: protos.vision.billing.v1.RetrieveProjectCreditsResponse.Result result = 1;
   */
  result?: RetrieveProjectCreditsResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.RetrieveProjectCreditsResponse.
 * Use `create(RetrieveProjectCreditsResponseSchema)` to create a new message.
 */
export const RetrieveProjectCreditsResponseSchema: GenMessage<RetrieveProjectCreditsResponse> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_retrieve_project_credits, 1);

/**
 * @generated from message protos.vision.billing.v1.RetrieveProjectCreditsResponse.Result
 */
export type RetrieveProjectCreditsResponse_Result = Message<"protos.vision.billing.v1.RetrieveProjectCreditsResponse.Result"> & {
  /**
   * @generated from field: int64 credits_refunded = 1;
   */
  creditsRefunded: bigint;
};

/**
 * Describes the message protos.vision.billing.v1.RetrieveProjectCreditsResponse.Result.
 * Use `create(RetrieveProjectCreditsResponse_ResultSchema)` to create a new message.
 */
export const RetrieveProjectCreditsResponse_ResultSchema: GenMessage<RetrieveProjectCreditsResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_retrieve_project_credits, 1, 0);

